// extracted by mini-css-extract-plugin
module.exports = {"footerWarning":"JaTL6","footerWarningNew":"_3_S1d","noEmergencyLearnMoreNew":"_2Lh7r"};